import { createFileRoute } from "@tanstack/react-router";
import TrapPage from "@/pages/TrapPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/trap-listings-export/")({
  head: () => routeHead("/trap-listings-export/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TrapPage />
  );
}
